import { gql } from '@apollo/client';

export const MEMBER_TAGS = gql`
    query MemberTags($popular: Boolean, $query: String) {
        memberTags(popular: $popular, query: $query) {
            id
            name
            slug
            category
            isCurated
            isApproved
            usageCount
        }
    }
`;
